import clone from "just-clone";

let isDevMode = false;
if(window.location.hostname.match(/localhost/) || (new URL(document.location.href)).pathname.match(/dev-mode/)) {
    isDevMode = true;
}

const urlParams = () => {
    const hrefElements = window.location.href.split("?");
    if(hrefElements.length <= 1) {
        return {};
    }

    const queryString = hrefElements[1].split("&");
    const params = {};

    for(let element of queryString) {
        const keyVal = element.split("=");
        if(keyVal.length >= 2) {
            if(["h","session_id", "offer"].indexOf(keyVal[0]) >= 0) {
                params[keyVal[0]] = keyVal[1];
            }
        }
    }

    return params;
};

const timestampSeconds = () => {
    return Math.floor((new Date()).getTime() / 1000);
}

// const isDaylightSaving = (date) => {
//     const jan = new Date(date.getFullYear(), 0, 1);
//     const jul = new Date(date.getFullYear(), 6, 1);
//     const stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
//     return date.getTimezoneOffset() < stdTimezoneOffset;
// };

const dateStringToObject = (ds, skipDaylightSaving = false) => {
    //  Safari won't tolerate creating a new Date from a "YYYY-MM-DD HH:mm:ss" date string
    //  It requires "YYYY-MM-DDTHH:mm:ss.sssZ" format
    if(ds instanceof Date) return ds;
    const date = new Date(ds.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/) ? ds.replace(" ", "T") + ".000Z" : ds);
    if(!skipDaylightSaving) date.setMinutes(date.getMinutes() + date.getTimezoneOffset());//  Handle daylight saving
    return date;
}

const dateStringsToObjects = (data, fieldNames) => {
    return data.map(record => {
        let r = clone(record);
        fieldNames.forEach(field => {
            if (record[field]) {
                r[field] = dateStringToObject(record[field]);
            }
        });

        return r;
    });
}

//  2023-02-06  Slightly hacked this line to hard-code "bookings" subdirectory into URL
const url = (path) => {
    const hostname = document.location.hostname.replace(/\/+$/, '');
    return `https://${hostname}/bookings/${path.replace(/\/+$/, '').replace(/^\/+/, '') }`;
};

const urlWithSessionParams = (path, session) => {
    let params = (session.custom_url_json && session.custom_url_json.params) ? 
        session.custom_url_json.params.reduce((acc, cur) => `${acc}&${cur.key}=${cur.value}`, "") : 
        "";

    return url(path) + `?sessionid=${session.code}${params}`;
};

const redirectWithSessionParams = (path, session) => {
    const url = urlWithSessionParams(path, session);
    console.log(`redirectWithSessionParams redirecting to `, url);
};

const redirect = (path) => { document.location.href = url(path); };

const newDate = () => {
    let d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
};

const dateAdd = (date, amt, type) => {
    const d = new Date(date.getTime());
    type = `${type ?? "ms"}`.toLowerCase();

    switch (type) {
        case "years":
        case "year":
        case "yr":
        case "y":
            d.setFullYear(d.getFullYear() + amt);
            break;
        case "months":
        case "month":
        case "mth":
        case "mon":
        case "mmm":
        case "mm":
            d.setMonth(d.getMonth() + amt);
            break;
        case "days":
        case "day":
        case "d":
            d.setTime(d.getTime() + (amt * 86400000));
            break;
        case "weeks":
        case "week":
        case "wk":
        case "w":
            d.setTime(d.getTime() + (amt * 7 * 86400000));
            break;
        case "hours":
        case "hour":
        case "hr":
        case "h":
            d.setTime(d.getTime() + (amt * 3600000));
            break;
        case "minutes":
        case "minute":
        case "min":
        case "m":
            d.setTime(d.getTime() + (amt * 60000));
            break;
        case "seconds":
        case "second":
        case "sec":
        case "s":
            d.setTime(d.getTime() + (amt * 1000));
            break;
        default://  ms
            d.setTime(d.getTime() + amt);
            break;
    }

    return d;
};
const dateSub = (date, amt, type) => { return dateAdd(date, 0 - (amt ?? 0), type ?? "ms"); };

const dateFormat = (date, format) => {
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let output;

    switch (format) {
        case "YYYY":
            return `${date.getFullYear()}`;
        case "YY":
            return `${date.getFullYear()}`.slice(-2);
        case "MMMM":
            return months[date.getMonth()];
        case "MMM":
            return months[date.getMonth()].slice(0, 3);
        case "MM":
            return `0${date.getMonth() + 1}`.slice(-2);
        case "DDDD":
            return days[date.getDay()];
        case "DDD":
            return days[date.getDay()].slice(0, 3);
        case "DD":
            return `0${date.getDate()}`.slice(-2);
        case "D":
            return `${date.getDate()}`;
        case "HH":
            return `0${date.getHours()}`.slice(-2);
        case "H":
            return `${date.getHours()}`;
        case "hh":
            output = date.getHours();
            return `0${output >= 13 ? output - 12 : output}`.slice(-2);
        case "h":
            output = date.getHours();
            return `${output >= 13 ? output - 12 : output}`;
        case "mm":
            return `0${date.getMinutes()}`.slice(-2);
        case "m":
            return `${date.getMinutes()}`;
        case "ss":
            return `0${date.getSeconds()}`.slice(-2);
        case "s":
            return `${date.getSeconds()}`;
        case "uuu":
            return `00${date.getMilliseconds()}`.slice(-3);
        case "uu":
            return `00${date.getMilliseconds()}`.slice(-3);
        case "u":
            return `${date.getMilliseconds()}`;
        case "A":
            return date.getHours() >= 12 ? "PM" : "AM";
        case "a":
            return date.getHours() >= 12 ? "pm" : "am";
        case "DD MMM YYYY":
            return `${dateFormat(date, "DD")} ${dateFormat(date, "MMM")} ${dateFormat(date, "YYYY")}`;
        case "DD/MM/YYYY":
            return `${dateFormat(date, "DD")}/${dateFormat(date, "MM")}/${dateFormat(date, "YYYY")}`;
        case "YYYY-MM-DD":
            return `${dateFormat(date, "YYYY")}-${dateFormat(date, "MM")}-${dateFormat(date, "DD")}`;
        case "ddd D MMM YYYY":
        case "DDD D MMM YYYY":
            return `${dateFormat(date, "DDD")} ${dateFormat(date, "D")} ${dateFormat(date, "MMM")} ${dateFormat(date, "YYYY")}`;
        case "dddd D MMM YYYY":
        case "DDDD D MMM YYYY":
            return `${dateFormat(date, "DDDD")} ${dateFormat(date, "D")} ${dateFormat(date, "MMM")} ${dateFormat(date, "YYYY")}`;
        case "dddd, D MMMM YYYY":
        case "DDDD, D MMMM YYYY":
            return `${dateFormat(date, "DDDD")}, ${dateFormat(date, "D")} ${dateFormat(date, "MMMM")} ${dateFormat(date, "YYYY")}`;
        case "dddd, D MMM - HH:mmA":
        case "DDDD, D MMM - HH:mmA":
            return `${dateFormat(date, "DDDD")}, ${dateFormat(date, "D")} ${dateFormat(date, "MMM")} - ${dateFormat(date, "HH")}:${dateFormat(date, "mm")}${dateFormat(date, "A")}`;
        case "h:mma":
        case "h:mmA":
            output = `${dateFormat(date, "h")}:${dateFormat(date, "mm")}${dateFormat(date, "a")}`;
            return format == "h:mmA" ? output.toUpperCase() : output;
        default:
            return `${dateFormat(date, "YYYY")}-${dateFormat(date, "MM")}-${dateFormat(date, "DD")} ${dateFormat(date, "HH")}:${dateFormat(date, "mm")}:${dateFormat(date, "ss")}`;
    }
};

//  Timestamp for when to start booking again if user fails to make progress.
//  It's 10 mins in future.
const nextStartAgainAt = () => (new Date()).getTime() + (10 * 60000);

const currentTimestamp = ()  => {
    return Math.floor(Date.now() / 1000);
};

const getLocalStorageSessionItems = () => {
    return { sessionId: localStorage.getItem("willow_ob_session_id") || "" };
};

const setLocalStorageSessionItems = session => {
    localStorage.setItem("willow_ob_session_id", session.code);   
};

const deleteSessionInLocalStorage = () => {
    localStorage.removeItem("willow_ob_session_id");
};

const moneyFormat = (val) => {
    const moneyVal = (Math.round(val * 100) / 100).toFixed(2);
    return `£${moneyVal}`; 
};

const pushToDataLayer = (event, data, deleteExistingEvents = false) => {
    window.dataLayer = window.dataLayer || [];

    if(deleteExistingEvents) {
        window.dataLayer = window.dataLayer.filter(ev => ev.event != event);
    }

    window.dataLayer.push({ event, data });
    // console.log(`window.dataLayer`, window.dataLayer);
};

export {
    urlParams, timestampSeconds, dateStringToObject, dateStringsToObjects, newDate, dateAdd, dateSub, dateFormat, 
    urlWithSessionParams, redirect, redirectWithSessionParams, nextStartAgainAt, currentTimestamp, 
    getLocalStorageSessionItems, setLocalStorageSessionItems, deleteSessionInLocalStorage, moneyFormat,
    pushToDataLayer, isDevMode
};
